import React from "react";
import {
  BsLinkedin,
  BsTwitter,
  BsFacebook,
  BsYoutube,
  BsInstagram,
  BsTiktok,
} from "react-icons/bs";
import { Link } from "react-router-dom";

const FPFooter: React.FC = () => {
  return (
    <div className="border-solid border-t border-[#E2E2EA] w-full lg:pt-10 pt-5 flex lg:flex-col flex-col-reverse">
      <div className="flex justify-center items-center w-full">
        <div className="flex gap-5 mx-auto md:mx-0 ">
          <BsLinkedin size={20} className="cursor-pointer " />
          <BsTwitter size={20} className="cursor-pointer" />
          <BsFacebook size={20} className="cursor-pointer" />
          <BsYoutube size={20} className="cursor-pointer" />
          <BsInstagram size={20} className="cursor-pointer" />
          <BsTiktok size={20} className="cursor-pointer" />
        </div>
      </div>
      <div className="lg:mt-12 w-full flex lg:flex-row flex-col lg:justify-between lg:gap-0 gap-4 mb-5 items-center font-Roboto text-sm font-normal ">
        <div className="text-sm text-[#000000] font-normal">Email send by Ecomoto</div>
        <div className=" flex lg:justify-between justify-around lg:px-0 px-10 lg:mt-0 text-[rgba(0,0,0,0.87)] lg:mb-0 lg:w-[37%] w-full items-center">
          <Link to="/policies/terms-of-service" className="cursor-pointer">
            Terms & Conditions
          </Link>
          <div className="bg-[#000000] w-[5px] h-[5px] rounded-full"></div>

          <div className="">Privacy policy</div>
        </div>
        <div className="lg:hidden text-base text-[#000000]">See you Soon.</div>
      </div>
    </div>
  );
};

export default FPFooter;
